import React from "react"
import { Modal } from "react-bootstrap"
import { Bold } from "../../../../../_partials/typography"
import { TextField, IconButton, Grid, makeStyles } from "@material-ui/core"
import ImageUploading from "react-images-uploading"
import CloseIcon from "@material-ui/icons/Close"
import { Button } from "../../../../../_partials/Button"
import { IoMdPhotos } from "react-icons/io"
import { AiFillCamera } from "react-icons/ai"

const CreateAnchorModal = ({
	showCreatePOIs,
	show,
	setShow,
	setShowCreatePOIs,
	setImages,
	dataCreatePoi,
	setDataCreatePoi,
	setShowWebcamModal,
	images,
	onChange,
	maxNumber,
	handleClose,
	conditionToDisable,
	startButtonProgress,
	handleSubmit,
	activeAnchors,
	anchorsPositioning
}) => {
	const classes = useStyles()

	const [UUIDError, setUUIDError] = React.useState(false)

	// React.useEffect(() => {
	// 	console.log(UUIDError, "UUIDError")
	// 	console.log(activeAnchors, "activeAnchors 2")
	// 	console.log("🚀  anchorsPositioning:", anchorsPositioning)
	// }, [anchorsPositioning, activeAnchors, UUIDError])

	return (
		<div>
			<Modal
				show={showCreatePOIs}
				style={{ visibility: show ? "hidden" : "visible" }}
				onHide={() => {
					setShowCreatePOIs(false)
					setImages([])
					setUUIDError(false)
				}}
				contentClassName="bg-transparent"
			>
				<Modal.Body
					style={{
						padding: "0",
						backgroundColor: "#FFF",
						borderRadius: "10px",
						overflow: "hidden"
					}}
				>
					<div className="pl-7 pr-7 pb-7 pt-2">
						{/* ━━━━━━  TITLE ━━━━━━ */}
						<div className="d-flex align-items-center justify-content-between">
							<div>
								<Bold>Create Anchor</Bold>
							</div>
							<div>
								<IconButton
									onClick={() => {
										setShowCreatePOIs(false)
										setImages([])
										setUUIDError(false)
									}}
									style={{ left: "12px" }}
								>
									<CloseIcon />
								</IconButton>
							</div>
						</div>

						{/* ━━━━━━  BODY  ━━━━━━ */}
						<Grid container spacing={2} className="mt-3">
							<Grid item xs={12} sm={12}>
								<div style={{ marginBottom: "10px" }}>
									<span className={classes.label}>UUID</span>
								</div>
								<TextField
									id="anchors_page_uuid_input_type_number"
									type="number"
									className={classes.input2}
									placeholder="Enter UUID"
									error={UUIDError}
									// helperText={UUIDError ? "This UUID already exists." : ""}
									value={dataCreatePoi.uuid || ""}
									onKeyDown={e => {
										// Prevent commas or periods when the input is empty
										if (
											e.key === "," ||
											e.key === "." ||
											e.key === "e" ||
											e.key === "E"
										) {
											if (!dataCreatePoi.uuid || dataCreatePoi.uuid === "") {
												e.preventDefault()
											}
										}
									}}
									onChange={e => {
										const el = document.getElementById(
											"anchors_page_uuid_input_type_number"
										)

										el &&
											el.addEventListener("keypress", function (e) {
												if (
													(e.code === "Comma" ||
														(e.code === "Period") | (e.code === "KeyE")) &&
													!dataCreatePoi.uuid
												) {
													e.preventDefault()
												}
											})

										const inputText = e.target.value

										const formattedValue = inputText.replace(/\D/g, "")

										// Prevent commas or periods when the input is empty
										if (
											!formattedValue &&
											(inputText.includes(",") || inputText.includes("."))
										) {
											e.preventDefault()
										}

										// const anchorWithSameUUIDActive =
										// 	activeAnchors &&
										// 	activeAnchors.some(
										// 		anchor => anchor.uuid === Number(formattedValue)
										// 	)

										// const anchorWithSameUUID =
										// 	anchorsPositioning &&
										// 	anchorsPositioning.some(
										// 		anchor => anchor.uuid === Number(formattedValue)
										// 	)

										// if (!anchorWithSameUUIDActive && !anchorWithSameUUID) {
										setDataCreatePoi({
											...dataCreatePoi,
											uuid: formattedValue
										})
										setUUIDError(false)
										// } else {
										// 	setDataCreatePoi({
										// 		...dataCreatePoi,
										// 		uuid: formattedValue
										// 	})
										// 	setUUIDError(true)
										// }
									}}
									size="small"
									color="primary"
									variant="outlined"
								/>
							</Grid>

							{UUIDError ? (
								<span
									style={{
										color: "#E65019",
										fontSize: "8px",
										marginLeft: "1rem"
									}}
								>
									This UUID already exists.
								</span>
							) : null}
							{/* <Grid item xs={12} sm={12}>
								<div style={{ marginBottom: "10px" }}>
									<span className={classes.label}>Name</span>
								</div>
								<TextField
									type="text"
									className={classes.input2}
									placeholder="Enter name"
									// error={dataCreatePoi.nameError?.length === 0 ? false : true}
									// helperText={dataCreatePoi.nameError}
									value={dataCreatePoi.node_name}
									onChange={e => {
										setDataCreatePoi({
											...dataCreatePoi,
											node_name: e.target.value
										})
									}}
									size="small"
									color="primary"
									variant="outlined"
								/>
							</Grid> */}

							<Grid item xs={12} sm={6}>
								<Button
									className="addImagesBtn"
									onClick={() => setShowWebcamModal(true)}
									variant="contained"
									color="primary"
									style={{
										fontWeight: "500",
										backgroundColor: "#3077d3",
										color: "#f4f4f4"
									}}
									size="medium"
									endIcon={
										<AiFillCamera
											style={{
												fontSize: "17px"
											}}
										/>
									}
									text="Take a photo"
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<ImageUploading
									multiple
									value={images}
									onChange={onChange}
									maxNumber={maxNumber}
									dataURLKey="data_url"
								>
									{({
										imageList,
										onImageUpload,
										onImageRemoveAll,
										onImageUpdate,
										onImageRemove,
										isDragging,
										dragProps
									}) => (
										// write your building UI
										<Grid container>
											<Button
												className="addImagesBtn"
												onClick={onImageUpload}
												{...dragProps}
												variant="contained"
												color="primary"
												style={{
													fontWeight: "500",
													backgroundColor: "#3077d3",
													color: "#f4f4f4"
												}}
												size="medium"
												endIcon={
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="20"
														height="19"
														viewBox="0 0 20 19"
														fill="none"
													>
														<path
															d="M2.28125 1.78125H3.46875V2.96875H2.28125V1.78125ZM5.84375 1.78125H4.65625V2.96875H5.84375V1.78125ZM16.5312 1.78125H17.7188V2.96875H16.5312V1.78125ZM17.7188 4.15625H16.5312V5.34375H17.7188V4.15625ZM16.5312 6.53125H17.7188V7.71875H16.5312V6.53125ZM16.5312 9.5H14.5842L14.2612 8.53053C14.1825 8.29402 14.0313 8.08832 13.8291 7.9426C13.6268 7.79689 13.3838 7.71857 13.1346 7.71875H10.4279C10.1786 7.71857 9.93559 7.79693 9.73335 7.9427C9.53111 8.08847 9.37993 8.29425 9.30128 8.53082L8.97833 9.5H7.03125C6.71642 9.50036 6.41458 9.62559 6.19196 9.84821C5.96934 10.0708 5.84411 10.3727 5.84375 10.6875V16.0313C5.84411 16.3461 5.96934 16.6479 6.19196 16.8705C6.41458 17.0932 6.71642 17.2184 7.03125 17.2188H16.5312C16.8461 17.2184 17.1479 17.0932 17.3705 16.8705C17.5932 16.6479 17.7184 16.3461 17.7188 16.0313V10.6875C17.7184 10.3727 17.5932 10.0708 17.3705 9.84821C17.1479 9.62559 16.8461 9.50036 16.5312 9.5ZM11.7812 15.4375C11.3115 15.4375 10.8523 15.2982 10.4618 15.0372C10.0712 14.7763 9.76679 14.4053 9.58704 13.9714C9.40728 13.5374 9.36024 13.0599 9.45188 12.5992C9.54352 12.1385 9.76972 11.7153 10.1019 11.3831C10.434 11.051 10.8572 10.8248 11.3179 10.7331C11.7786 10.6415 12.2561 10.6885 12.6901 10.8683C13.1241 11.048 13.495 11.3525 13.756 11.743C14.017 12.1336 14.1562 12.5928 14.1562 13.0625C14.1555 13.6922 13.9051 14.2959 13.4598 14.7411C13.0146 15.1863 12.4109 15.4368 11.7812 15.4375ZM11.7812 14.25C12.4371 14.25 12.9688 13.7183 12.9688 13.0625C12.9688 12.4067 12.4371 11.875 11.7812 11.875C11.1254 11.875 10.5938 12.4067 10.5938 13.0625C10.5938 13.7183 11.1254 14.25 11.7812 14.25ZM15.3438 1.78125H14.1562V2.96875H15.3438V1.78125ZM11.7812 1.78125H12.9688V2.96875H11.7812V1.78125ZM10.5938 1.78125H9.40625V2.96875H10.5938V1.78125ZM7.03125 1.78125H8.21875V2.96875H7.03125V1.78125ZM3.46875 4.15625H2.28125V5.34375H3.46875V4.15625ZM2.28125 6.53125H3.46875V7.71875H2.28125V6.53125ZM3.46875 8.90625H2.28125V10.0938H3.46875V8.90625ZM2.28125 11.2812H3.46875V12.4688H2.28125V11.2812ZM3.46875 13.6562H2.28125V14.8438H3.46875V13.6562ZM2.28125 16.0312H3.46875V17.2188H2.28125V16.0312Z"
															fill="white"
														/>
													</svg>
												}
												text="	Add or Drop Images"
											/>
											{/* <progress
                        value={progress}
                        max='100'
                        style={{ width: "100%" }}
                      /> */}
											<Modal
												show={show}
												onHide={handleClose}
												contentClassName="bg-transparent"
											>
												<Modal.Body
													style={{
														padding: "0",
														backgroundColor: "#FFF",
														borderRadius: "10px",
														overflow: "hidden"
													}}
												>
													<div className="pl-7 pr-7 pb-7 pt-2">
														{/* ━━━━━━  TITLE ━━━━━━ */}
														<div className="d-flex align-items-center justify-content-between">
															<div>
																<Bold>Add Images To Marker</Bold>
															</div>
															<div>
																<IconButton
																	onClick={() => {
																		setShow(false)
																		setImages([])
																	}}
																	style={{ left: "12px" }}
																>
																	<CloseIcon />
																</IconButton>
															</div>
														</div>

														{/* ━━━━━━  BODY ━━━━━━ */}
														<Grid
															container
															direction="row"
															className="d-flex justify-content-center"
														>
															{imageList.map((image, index) => (
																<div
																	key={index}
																	className="image-item text-center m-3"
																>
																	<div className="addDropDiv">
																		<img
																			src={image["data_url"]}
																			alt="office points of interest"
																			width="100"
																			className="addDropImg"
																			style={{
																				borderRadius: "0"
																			}}
																		/>
																	</div>
																	<div className="image-item__btn-wrapper mb-4">
																		<Button
																			// style={{
																			// 	height: "2.7vh"
																			// }}
																			text="Remove"
																			className={classes.button4}
																			variant="outlined"
																			color="primary"
																			onClick={() => {
																				onImageRemove(index)
																				/* //console.log(
										imageList.length,
										"imageList.length"
									  ) */
																				// closes modal if remove button pressed without any image left
																				if (imageList.length <= 1) {
																					handleClose()
																				}
																			}}
																		/>
																		<Button
																			// style={{
																			// 	height: "2.7vh"
																			// }}
																			className={classes.button4}
																			variant="contained"
																			color="primary"
																			onClick={() => onImageUpdate(index)}
																			text="Update"
																		/>
																	</div>
																</div>
															))}
														</Grid>

														{/* ━━━━━━  FOOTER ━━━━━━ */}
														<div className="d-flex">
															<Button
																fullWidth
																color="primary"
																variant="outlined"
																onClick={handleClose}
																className="mr-2"
																style={{
																	padding: "0"
																}}
																text="Cancel"
															/>
															<Button
																fullWidth
																variant="contained"
																color="primary"
																onClick={() => {
																	onImageRemoveAll()
																	handleClose()
																}}
																className="ml-2"
																text="Remove All"
															/>
															<Button
																fullWidth
																variant="contained"
																color="primary"
																onClick={() => {
																	onImageUpload()
																	handleClose()
																}}
																className="ml-2"
																text="Add Images"
															/>
															<Button
																fullWidth
																variant="contained"
																color="primary"
																onClick={e => {
																	// uploadHandler(e); // old code of creation POI
																	handleClose()
																}}
																className="ml-2"
																text="Next"
															/>
														</div>
													</div>
												</Modal.Body>
											</Modal>
										</Grid>
									)}
								</ImageUploading>
							</Grid>
							<Grid item xs={12}>
								<div style={{ marginBottom: "10px" }}>
									<span className={classes.label}>Description</span>
								</div>
								<TextField
									className={classes.input2}
									style={{ width: "100%" }}
									placeholder="Describe the exact location where you installed the anchor..."
									error={dataCreatePoi.descriptionError?.length === 0 ? false : true}
									// helperText={dataCreatePoi.descriptionError}
									value={dataCreatePoi.description}
									onChange={e =>
										setDataCreatePoi({
											...dataCreatePoi,
											description: e.target.value
										})
									}
									size="medium"
									color="primary"
									variant="outlined"
									multiline
									rows={4}
								/>
							</Grid>
						</Grid>

						{/* ━━━━━━  FOOTER ━━━━━━ */}
						<div className="d-flex mt-4">
							<Button
								fullWidth
								color="primary"
								variant="outlined"
								onClick={() => {
									setShowCreatePOIs(false)
									setImages([])
									setUUIDError(false)
									// handleDeleteFromStorage(urls); // Don't need to delete anymore from storage on cancel. If cancel is pressed delete from storage uploaded images
								}}
								className="mr-2"
								text="Cancel"
							/>
							<Button
								disabled={conditionToDisable || UUIDError}
								fullWidth
								// style={{
								// 	backgroundColor: conditionToDisable ? "#E0E0E0" : "#3077d3",
								// 	color: "#f4f4f4",
								// 	fontWeight: "500"
								// }}
								variant="contained"
								color="primary"
								onClick={() => {
									// Starts the change of the saving UI button like progress bar
									const buttonToProgressEl = document.getElementById(
										"buttonToProgress_createPoi"
									)
									buttonToProgressEl &&
										startButtonProgress(
											buttonToProgressEl,
											"button__progress_createPoi",
											"button__text_createPoi"
										)

									handleSubmit() // Save create POI
								}}
								className="ml-2"
								id="buttonToProgress_createPoi"
								data-progress-text="Saving..."
								data-complete-text="Save complete."
							>
								<div className="button__progress_createPoi"></div>
								<span
									className="button__text_createPoi"
									style={{
										fontFamily: "Poppins",
										fontWeight: "700"
									}}
								>
									Create
								</span>
							</Button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default CreateAnchorModal

const useStyles = makeStyles(theme => ({
	input2: {
		width: "100%",
		backgroundColor: "#F2F2F2",
		borderRadius: "4px",
		"& .MuiOutlinedInput-root": {
			"& fieldset": {
				borderColor: "#F2F2F2"
			}
		}
	},

	label: {
		color: "#4A4A68",
		fontFamily: "Poppins",
		fontSize: "12px",
		fontWeight: "500"
	}
}))
